import Splide from '@splidejs/splide';

let quoteSlides = document.getElementsByClassName('quote-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < quoteSlides.length; i++) {
        let splide = new Splide(quoteSlides[i], {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%'
        });

        let indicatorCurrent = splide.root.querySelector('.splide-indicator .current');
        let indicatorTotal= splide.root.querySelector('.splide-indicator .total');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            indicatorCurrent.innerHTML = splide.index + 1;
            indicatorTotal.innerHTML = end;
        });

        splide.mount();
    }
});
